import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Header, Grid } from "semantic-ui-react";

const style = {
  root: {
    width: "100%"
  },
  noPadding: {
    padding: "0px"
  },
  formPadding: {
    padding: "10%",
    textAlign: "center"
  }
};

const CardSendDoctorQueue = props => {
  return (
    <Card style={style.root}>
      <Card.Content>
        <div style={style.formPadding}>
          <Header>
            ยืนยันการส่งเข้าคิวแพทย์ เพื่อส่งปรึกษาเพิ่มเติมหรือไม่
          </Header>
        </div>
        <Grid>
          <Grid.Row columns={2} style={style.noPadding}>
            <Grid.Column width={8} style={style.noPadding}>
              <Button fluid color="red" onClick={props.hideCallback}>
                ยกเลิก
              </Button>
            </Grid.Column>
            <Grid.Column width={8} style={style.noPadding}>
              <Button fluid color="green">
                ยืนยัน
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};

CardSendDoctorQueue.defaultProps = {
  hideCallback: () => {}
};

CardSendDoctorQueue.propTypes = {
  hideCallback: PropTypes.func
};

export default React.memo(CardSendDoctorQueue);
